import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { DebtorListView } from 'src/sections/cheque-factoring/view';

export default function FactoringDebtorListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Debtors</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_FACTORING_DEBTOR,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <DebtorListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
